import { FormControl } from '@material-ui/core';
import { Form } from 'formik';
import React from 'react';
import styled from 'styled-components/macro';

const Root = styled.div`
  width: 100%;

  .MuiTextField-root {
    margin: .75em 0;
  }  
`;

export default ({ children, fullWidth }) => (
  <Root>
    <Form>
      <FormControl fullWidth={fullWidth}>
        {children}
      </FormControl>
    </Form>
  </Root>
);
